import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

/** Third-party provider integrations — mirrors stacks-agents `src/app/api/integrations/`. */
@Injectable({ providedIn: 'root' })
export class IntegrationsApiService {
  constructor(private http: HttpClient) {}

  /** Builder JWT for the stacks-agents API */
  private agentsAuthHeaders(): HttpHeaders {
    return new HttpHeaders({ Authorization: `Bearer ${localStorage.getItem('token')}` })
  }

  getIntegrations(projectId: string): Promise<Record<string, any>> {
    return this.http
      .get<{ data?: Record<string, any> }>(`${environment.agentsUrl}v4/retrieval/integrations`, {
        headers: this.agentsAuthHeaders(),
        params: { projectId },
      })
      .pipe(
        map(body => body?.data ?? {}),
        catchError(() => of({})),
      )
      .toPromise() as Promise<Record<string, any>>
  }

  /** Upserts per-provider integration rows from a flat integrations object. */
  async saveIntegrations(projectId: string, integrations: Record<string, any>): Promise<void> {
    await this.http
      .post(`${environment.agentsUrl}v4/creation/integrations`, { projectId, integrations }, {
        headers: this.agentsAuthHeaders(),
      })
      .pipe(catchError(() => of(null)))
      .toPromise()
  }

  /** Flips only the connected flag for a single integration provider. */
  async setIntegrationConnected(projectId: string, provider: string, connected: boolean): Promise<void> {
    await this.http
      .post(`${environment.agentsUrl}v4/creation/integrations`, { projectId, provider, connected }, {
        headers: this.agentsAuthHeaders(),
      })
      .pipe(catchError(() => of(null)))
      .toPromise()
  }
}
